export const EXPANDABLE_DIALOG_WITH_SIDEBAR_SECTION_NAME = "ExpandableDialogWithSidebarSection";
export const EXPANDABLE_DIALOG_WITH_SIDEBAR_SUBSECTION_NAME = "ExpandableDialogWithSidebarSubsection";
